import {computed} from 'mobx';

import {BaseModel} from "../../../../infrastructure/models/base-model";
import {BaseRouteConfig} from "./base-route-config";
import {DEFAULT_CULTURE_NAME} from "../../../app/consts";
import {BaseRouteMetaDataModel} from "../../../../infrastructure/models/route/base-route.meta-data.model";

export class RouteModel extends BaseModel {
  config: BaseRouteConfig;
  cultureName: String;
  Component: Object;
  metadata: BaseRouteMetaDataModel;

  constructor(config: BaseRouteConfig, cultureName: String, metadataType, pages = []) {
    super();

    this.config = config;
    this.cultureName = cultureName;
    this.metadata = metadataType;
    this.pages = pages;
  }

  get name(): String {
    return this.config?.name;
  }

  get parent(): String {
    return this.config?.parent;
  }

  @computed get path(): String {
    const isDefaultCultureName: Boolean = this.cultureName === DEFAULT_CULTURE_NAME;
    const isPageRoute: Boolean = this.config.path?.charAt(0) !== "/";

    const path: String = isPageRoute ? this.config.path : (isDefaultCultureName ? this.config.path : '/' + this.cultureName + this.config.path);

    return path;
  }

  @computed get parentPath(): String {
    const path: String = this.cultureName === DEFAULT_CULTURE_NAME ? this.config?.parentPath : '/' + this.cultureName + this.config?.parentPath;

    return path;
  }

  get isSubRoute(): Boolean {
    return !!this.parent && !this.config.scrollToTop;
  }
}
